import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getMonthlySalesReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import { reportMonthlySalesReport } from 'utils/breadcrumbInfo';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class MonthlySalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `MonthlySalesReportBeginDate`);
        this.props.formInput(date, `MonthlySalesReportEndDate`)
        // this.cleanSearch();
        this.filter();
    }

    cleanSearch = () => {
        this.props.clearFormInput(`MonthlySalesReportBeginDate`);
        this.props.clearFormInput(`MonthlySalesReportEndDate`);
        this.props.clearFormInput(`MonthlySalesReportBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;

        this.props.getMonthlySalesReport({ beginDate, endDate, pageNumber, pageSize, branch });

    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageNumber = 1;
        let pageSize = 999999;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.getCsvReport(`reports/excel/salesreport?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}&pageNumber=${pageNumber}&pageSize=${pageSize}&timemodel=2`, "salesreport");
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.monthlySalesReport.list.length > 0 ? newProps.monthlySalesReport.list[0].totalRows : 0;
            this.setState({ totalRow: totalRow })
        }
    }

    render() {
        // let viewModel = this.getTaxViewModel();
        //const totalRow = this.props.monthlySalesReport.length > 0 ? this.props.monthlySalesReport[0].totalRows : 0;
        //console.log("****************size" + totalRow);
        return (
            <Grid headerContent={reportMonthlySalesReport}>
                <div className="bg-light-opacity">
                    <div className="row m-0 pa-2">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <h2>{LOOKUP.report.monthlySalesReport.text} </h2>
                            <h5>{LOOKUP.report.monthlySalesReport.description}</h5>
                        </div>
                    </div>
                    <div className="pa-2">
                        <Header
                            loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                        {
                            this.state.showBody &&
                            <p className="text-right mt-2 blue-text">
                                <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                            </p>
                        }
                    </div>
                </div>
                <div id="patient-list-table">
                    {
                        this.state.showBody &&
                        <CardSimple>
                            <Body monthlySalesReport={this.props.monthlySalesReport} beginDate={this.props.beginDate} endDate={this.props.endDate} />

                            <Pagination
                                length={this.state.totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    }
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        monthlySalesReport: state.reports.monthlySalesReport,
        loggedBranch: state.common.branchId,
        beginDate: state.form.MonthlySalesReportBeginDate,
        endDate: state.form.MonthlySalesReportEndDate,
        branch: state.form.MonthlySalesReportBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMonthlySalesReport: model => dispatch(getMonthlySalesReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(MonthlySalesReport));